import { start, cancelTests, runIndividualTask } from "../SelfHelp";
import { downloadBlob } from "./BlobHelper";
import { showAllDetails, hideAllDetails, toggleAccordionDataDisplay } from "./DomHelper";
const global = window;
const { selfHelp: { useTelemetry } } = global;
/** Adds an event listener to the "run tasks" button which triggers the beginning of the diagnostics */
function addRunTasksListener() {
    const runTasksBtn = document.getElementById("shdid-run-tasks-btn");
    $(runTasksBtn).click((evt) => {
        evt.preventDefault();
        start();
    });
}
/** Adds an event listener to the "cancel" button which cancels the execution of tests where they"re at */
function addCancelTestsListener() {
    const cancelTasksBtn = document.getElementById("shdid-cancel-tasks-btn");
    $(cancelTasksBtn).click((evt) => {
        evt.preventDefault();
        cancelTests();
    });
}
/** Adds event listener so that accordion drops down when "Show Details" is clicked */
function addAccordionListener() {
    document.querySelectorAll(".shd-accordion-show-details").forEach((button) => {
        $(button).click(() => {
            const key = button.id.split("-")[1];
            toggleAccordionDataDisplay(key);
        });
    });
}
/** Adds event listener for when checkbox becomes checked / unchecked */
function addCheckboxListener() {
    const checkbox = document.getElementById("shdid-shd-show-details-checkbox");
    checkbox.addEventListener("change", function () {
        if ($(this).is(":checked")) {
            showAllDetails();
        }
        else {
            hideAllDetails();
        }
    });
}
/** Adds event listener to individual "Run task" buttons */
function addRunTaskAgainListener() {
    document.querySelectorAll(".shd-run-tasks-again-btn").forEach((button) => {
        $(button).click((evt) => {
            evt.preventDefault();
            const taskId = button.id.split("-")[1];
            runIndividualTask(taskId);
        });
    });
}
/**
 * Adds event listener to "Download Blob" button, calls function in Blob helper
 * so that download will not be blocked by browser
 */
function addBlobHelperListener() {
    const button = document.getElementById("shdid-download-blob-link");
    $(button).click((evt) => {
        evt.preventDefault();
        downloadBlob();
    });
}
/** Adds event listener for telemetry feedback */
function feedbackHelpfulListener() {
    const button = document.getElementById("shdid-telemetry-yes");
    $(button).click((evt) => {
        evt.preventDefault();
    });
}
/** Adds event listener for telemetry feedback */
function feedbackNotHelpfulListener() {
    const button = document.getElementById("shdid-telemetry-no");
    $(button).click((evt) => {
        evt.preventDefault();
    });
}
/** Function triggers adding all the event listeners to the page */
export function addListeners() {
    addRunTasksListener();
    addCancelTestsListener();
    addAccordionListener();
    addCheckboxListener();
    addRunTaskAgainListener();
    addBlobHelperListener();
    if (useTelemetry) {
        feedbackHelpfulListener();
        feedbackNotHelpfulListener();
    }
}
//# sourceMappingURL=EventListenerHelper.js.map